import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import useFilter from "../../../../../hook/useFilter"
import useVariable from "../../../../../hook/useVariable"
import { orderActions } from "../../../../../store/orders-slice"
import { userActions } from "../../../../../store/user-slice"
import Pagination from "./pagination"

const Filter = (props) => {

    let defaultordercount = useSelector((state) => state.order.filterOrderCount)
    let pagination = useSelector((state) => state.order.pagination)

    let sliceFilters = useSelector(state => state.order.filter)
    let sliceActions = orderActions
    let sliceItems = useSelector(state => state.order.orders)
    const [isMount, setIsMount] = useState(false)

    const { children } = props


    let dispatch = useDispatch()

    const { doFilter } = useFilter()
    const { variableValue } = useVariable()

    const [paginationItems, setPaginationItems] = useState([])

    useEffect(() => {
        let items = []
        if (pagination) {
            pagination.map((item, key) => {

                items.push(<Pagination key={key} orders={item} index={key} />)
            })
        }

        setPaginationItems(items)
    }, [pagination])



    useEffect(() => {

        if (!isMount) {
            setIsMount(true)
            return
        }

        doFilter(sliceFilters, sliceItems, sliceActions)


    }, [sliceFilters])


    return <div className="p-3" >
        <div style={{ display: 'flex', justifyContent: 'space-between' }} >
            <div>
                <label>Pagination</label> <select name="filter-pagination" defaultValue={sliceFilters.pagination} className="mb-2" onChange={(event) => {
                    let value = variableValue(event.target.value)

                    dispatch(orderActions.setFilter({
                        key: 'pagination',
                        value
                    }))



                }} >
                    <option value='' >All</option>

                    {
                        defaultordercount.map((item, key) => {

                            return <option key={key} value={item} >{item}</option>
                        })
                    }
                </select>

                <input type="text" name="filter-product_title-order_id" className="mb-2" defaultValue={sliceFilters.search} placeholder="order id or product title" onInput={(event) => {
                    let value = variableValue(event.target.value)


                    dispatch(orderActions.setFilter({
                        key: 'search',
                        value
                    }))


                }} />
            </div>

        </div>
        {children}
        <div className="pagination-container">{paginationItems}</div>
       
    </div>
}


export default Filter